// extracted by mini-css-extract-plugin
module.exports = {"link":"_3lfWv","svgRoot":"_36XXs","nonScalingStroke":"_3Qjwl","overflowVisible":"_2Jrgb"};